import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CominicationService } from '../services/cominication.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit {
  show: boolean = false;
  resloverCalled = false;

  constructor(
    private comService: CominicationService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.comService.getMessage().subscribe((res) => {
      if (res.message == 'loading-show-resolver') {
        this.resloverCalled = true;
      }
      if (res.message == 'loading-hide-resolver') {
        this.resloverCalled = false;
      }
      if (res.message == 'loading-show') {
        this.showLoading();
      }
      if (res.message == 'loading-hide') {
        this.hideLoading();
      }
    });
  }

  showLoading() {
    this.show = true;
    this.cdRef.detectChanges();
  }

  hideLoading() {
    this.show = false;
    this.cdRef.detectChanges();
  }
}
